<template>
	<div id="wrapper">
    <apexchart
      type="donut"
      ref="chart"
      :width="'100%'"
      :options="chartOptions"
      :series="series"
      class="chart-wrapper"
      id="donut-participantes"
    ></apexchart>

    <!-- Leyenda personalizada -->
    <div class="legend-wrapper">
      <div
        class="legend-item"
        v-for="(label, index) in chartOptions.labels"
        :key="index"
      >
        <span
          :style="{ backgroundColor: data_chart.colors[index] }"
          class="legend-color"
        ></span>
        <span class="legend-label">{{ label }}</span>
        <span class="legend-value">
          {{ ((series[index] / totalSeries) * 100).toFixed(2) }}%
        </span>
      </div>
    </div>
	</div>
</template>

<script>
export default {
  name: 'DonutChart',
  props: ['width', 'height_chart', 'height_card', 'data_chart'],
  data() {
    return {
      series: this.data_chart.serie,
      chartOptions: {
        chart: {
          type: 'donut',
          fontFamily: 'Helvetica, Arial, sans-serif',
        },
        labels: this.data_chart.categories,
        colors: this.data_chart.colors,
        legend: {
          show: false, // usamos nuestra propia leyenda
        },
        plotOptions: {
          pie: {
            donut: {
              labels: { show: false },
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let total = series.reduce((a, b) => a + b, 0);
            let value = series[seriesIndex];
            let porcentaje = ((value / total) * 100).toFixed(2);
            let label = w.globals.labels[seriesIndex];
            return `
              <div style="
                background-color: #ffffff;
                border: 1px solid #E0E0E0;
                border-radius: 6px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                padding: 8px 10px;
                font-family: Helvetica, Arial, sans-serif;
                font-size: 13px;
                color: #7F7F7F;
                text-align: center;
              ">
                <div style="font-weight:600; color:#4A4A4A;">${label}</div>
                <div style="margin-top:2px; color:#2F48A3; font-weight:700;">
                  ${porcentaje}%
                </div>
              </div>`;
          },
          style: {
            fontFamily: 'Helvetica, Arial, sans-serif',
          },
        },
      },
    };
  },
  computed: {
    totalSeries() {
      return this.series.reduce((a, b) => a + b, 0);
    },
  },
};
</script>

<style lang="css" scoped>
#wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 85%;
  font-family: Helvetica, Arial, sans-serif;
}

/* === Leyenda personalizada consistente con .gray-font === */
.legend-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Helvetica, Arial, sans-serif;
}

.legend-color {
  width: 0.9vw;
  height: 0.9vw;
  display: inline-block;
  border-radius: 2px;
}

/* Colores y tamaños coherentes con el dashboard */
.legend-label {
  color: #7F7F7F; /* mismo color que .gray-font */
  font-weight: 500;
  font-size: clamp(0.85rem, 0.9vw, 1rem);
}

.legend-value {
  color: #2F48A3; /* mismo azul que .number */
  font-weight: 700;
  font-size: clamp(0.9rem, 1vw, 1.1rem);
}
</style>
